import { render, staticRenderFns } from "./edit-payment-category.vue?vue&type=template&id=9efb6d82"
import script from "./edit-payment-category.vue?vue&type=script&lang=ts"
export * from "./edit-payment-category.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports